export default "__VITE_ASSET__oy1fVt6I__"